import {
    getSortedItems,
    Menu as SourceMenu,
    TYPE_CATEGORY,
    TYPE_CMS_PAGE,
    TYPE_CUSTOM_URL
} from 'SourceUtil/Menu/Menu';

export {
    TYPE_CUSTOM_URL,
    TYPE_CMS_PAGE,
    TYPE_CATEGORY,
    getSortedItems
};

/** @namespace PeggysagePwa/Util/Menu */
export class Menu extends SourceMenu {
    getMenuData({
        cms_page_identifier,
        url,
        url_type,
        item_class,
        category_id,
        ...item
    }) {
        return {
            ...item,
            cms_page_identifier,
            category_id,
            item_class,
            url: this.getMenuUrl({ url, url_type, category_id }),
            children: {}
        };
    }
}

export default new Menu();
